const initialState = {
  test: 1,
};

// eslint-disable-next-line react-refresh/only-export-components
export default (state = initialState, { type }) => {
  switch (type) {
    default: {
      return state;
    }
  }
};

export { initialState };
